import axios from '../../axiosConfig'
import { tokenConfig } from '../auth'
import {
  FETCH_EX_TRATAMIENTOS,
  FETCH_TRATAMIENTOS_DISPONIBLES,
  FETCH_TRATAMIENTOS_DISPONIBLES_FAIL,
  GET_EX_TRATAMIENTOS,
  GET_TRATAMIENTOS_DISPONIBLES,
  SET_LISTA_LONGITUDES,
  SET_LISTA_TIPOS_TRATAMIENTO1,
  SET_LISTA_TRATAMIENTOS1,
  SET_LISTA_TRATAMIENTOS1_COMPLETA,
  SET_LISTA_TRATAMIENTOS2,
  SET_LISTA_TRATAMIENTOS2_COMPLETA,
  SET_TIPOS_TRATAMIENTO2,
  SET_VALORES_EMPAQUETADO,
  SET_VALORES_TRATAMIENTO2,
  UNSET_LISTAS_TRATAMIENTOS,
  UNSET_LISTA_EMPAQUETADO,
  UNSET_LISTA_LONGITUDES,
  UNSET_LISTA_TRATAMIENTOS1,
  UNSET_LISTA_TRATAMIENTOS1_COMPLETA,
  UNSET_LISTA_TRATAMIENTOS2,
} from '../types'

// GET EX TRATAMIENTOS
export const getExTratamientos = () => (dispatch, getState) => {
  dispatch({
    type: FETCH_EX_TRATAMIENTOS,
  })

  let config = tokenConfig(getState)

  axios
    .get(`/exTratamientos/`, config)
    .then(res => {
      dispatch({
        type: GET_EX_TRATAMIENTOS,
        payload: res.data,
      })
    })
    .catch(err => {
      console.log(err)
    })
}

// GET TRATAMIENTOS DISPONIBLES PARA PERFIL
export const getTratamientosDisponibles = (perfil, articulo) => (dispatch, getState) => {
  dispatch({
    type: FETCH_TRATAMIENTOS_DISPONIBLES,
  })

  let config = tokenConfig(getState)

  if (articulo == null || articulo === 'null') articulo = ''

  axios
    .post(
      `/getTratamientosDisponibles/get_tratamientos/?perfil=${perfil}&articulo=${articulo}`,
      {},
      tokenConfig(getState),
    )
    .then(res => {
      dispatch({
        type: GET_TRATAMIENTOS_DISPONIBLES,
        payload: res.data,
      })
    })
    .catch(err => {
      console.log(err)
      dispatch({
        type: FETCH_TRATAMIENTOS_DISPONIBLES_FAIL,
      })
    })
}

export const setListaTratamientos1Completa = valores => (dispatch, getState) => {
  dispatch({
    type: SET_LISTA_TRATAMIENTOS1_COMPLETA,
    payload: valores,
  })
}

export const unsetTratamientos1Completa = () => (dispatch, getState) => {
  dispatch({
    type: UNSET_LISTA_TRATAMIENTOS1_COMPLETA,
  })
}

export const setTiposTratamiento1 = valores => (dispatch, getState) => {
  dispatch({
    type: SET_LISTA_TIPOS_TRATAMIENTO1,
    payload: valores,
  })
}

export const setTratamientos1 = valores => (dispatch, getState) => {
  dispatch({
    type: SET_LISTA_TRATAMIENTOS1,
    payload: valores,
  })
}

export const unsetTratamientos1 = () => (dispatch, getState) => {
  dispatch({
    type: UNSET_LISTA_TRATAMIENTOS1,
  })
}

export const setListaTratamientos2Completa = valores => (dispatch, getState) => {
  dispatch({
    type: SET_LISTA_TRATAMIENTOS2_COMPLETA,
    payload: valores,
  })
}

export const setListaTratamientos2 = lista => (dispatch, getState) => {
  dispatch({
    type: SET_LISTA_TRATAMIENTOS2,
    payload: lista,
  })
}

export const setListaTiposTratamiento2 = lista => (dispatch, getState) => {
  dispatch({
    type: SET_TIPOS_TRATAMIENTO2,
    payload: lista,
  })
}

export const setListaValoresTratamiento2 = lista => (dispatch, getState) => {
  dispatch({
    type: SET_VALORES_TRATAMIENTO2,
    payload: lista,
  })
}

export const unsetTratamientos2 = () => (dispatch, getState) => {
  dispatch({
    type: UNSET_LISTA_TRATAMIENTOS2,
  })
}

export const setListaEmpaquetado = lista => (dispatch, getState) => {
  dispatch({
    type: SET_VALORES_EMPAQUETADO,
    payload: lista,
  })
}

export const setListaValoresEmpaquetado = lista => (dispatch, getState) => {
  dispatch({
    type: SET_VALORES_EMPAQUETADO,
    payload: lista,
  })
}

export const unsetListaEmpaquetado = () => (dispatch, getState) => {
  dispatch({
    type: UNSET_LISTA_EMPAQUETADO,
  })
}

export const setListaLongitudes = valores => (dispatch, getState) => {
  dispatch({
    type: SET_LISTA_LONGITUDES,
    payload: valores,
  })
}

export const unsetListaLongitudes = () => (dispatch, getState) => {
  dispatch({
    type: UNSET_LISTA_LONGITUDES,
  })
}

export const unsetListasTratamientos = () => (dispatch, getState) => {
  dispatch({
    type: UNSET_LISTAS_TRATAMIENTOS,
  })
}
